export enum CarmResources {
    DOA = "DOA",
    CLIENT_GROUPS = "CLIENT_GROUPS",
    CLIENT_TRANSACTION_HISTORY = "CLIENT_TRANSACTION_HISTORY",
    ALERTS = "ALERTS",
    API = "API",
    PROGRAM_ENROLMENT = "PROGRAM_ENROLMENT",
    PERSONAL_PROFILE = "PERSONAL_PROFILE",
    BUSINESS = "BUSINESS",
    PROGRAM = "PROGRAM",
    TRANSACTION_HISTORY = "TRANSACTION_HISTORY",
    MAKE_PAYMENT = "MAKE_PAYMENT",
    FINANCIAL_STATEMENTS = "FINANCIAL_STATEMENTS",
    INTEREST_SIMULATION = "INTEREST_SIMULATION",
    COLLECTIONS = "COLLECTIONS",
    BONDS_DASHBOARD = "BONDS_DASHBOARD",
    BONDS_LIST = "BONDS_LIST",
    APPLY_CREDITS = "APPLY_CREDITS",
    PAYMENTS = "PAYMENTS",
    DUTY_AND_TAX = "DUTY_AND_TAX",
    DECLARATIONS = "DECLARATIONS",
    DECLARATIONS_REPORTING = "DECLARATIONS_REPORTING",
    DECLARATIONS_SDA = "DECLARATIONS_SDA",
    DECLARATIONS_DDB_NONIMP = "DECLARATIONS_DDB_NONIMP",
    RULINGS = "RULINGS",
    APPEALS = "APPEALS",
    ENFORCEMENT_ACTIONS = "ENFORCEMENT_ACTIONS",
    COMPLIANCE = "COMPLIANCE",
    DOCUMENTS = "DOCUMENTS",
    NOTIFICATIONS = "NOTIFICATIONS",
    REGISTRATION = "REGISTRATION",
    STAFFMEMBER_ACCESS_REQUEST = "STAFFMEMBER_ACCESS_REQUEST",
    SURETY_PROVIDER = 'SURETY_PROVIDER',
    MANAGE_RELATIONSHIPS = 'MANAGE_RELATIONSHIPS',
    STAFFMEMBERGROUP = "STAFFMEMBERGROUP",
    ORPHAN_USER = "ORPHAN_USER",
    BROKER_SUMMARY = "BROKER_SUMMARY",
    EMPLOYEE = "EMPLOYEE",
    MENU = "MENU",
    PROGRAM_PROFILE_SUBPROGRAM = "PROGRAM_PROFILE_SUB_PROGRAM",
    PROGRAM_PROFILE_EDI = "PROGRAM_PROFILE_EDI",
    PROGRAM_PROFILE_OWNERS = "PROGRAM_PROFILE_OWNERS",
    DECLARATIONS_BUSINESS_SWAP = "DECLARATIONS_BUSINESS_SWAP",
    SOA_BUSINESS = "SOA_BUSINESS",
    SOA_INTRA_PROGRAM = "SOA_INTRA_PROGRAM",
    SOA_PROGRAM = "SOA_PROGRAM",
}
